import { render, staticRenderFns } from "./ResetUserPasswordMenu.vue?vue&type=template&id=dc587026&"
import script from "./ResetUserPasswordMenu.vue?vue&type=script&lang=ts&"
export * from "./ResetUserPasswordMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports